import { filterTypes } from '../../config';

/**
 * Process filter selection based on filter type
 */
export const processFilterSelection = (prevFilters, target, filterType, menuFilter) => {
    const newFilters = { ...prevFilters };
    
    switch (filterType) {
        case filterTypes.category:
            return processCategoryFilter(newFilters, target);
            
        case filterTypes.brands:
        case filterTypes.effects:
        case filterTypes.weights:
        case filterTypes.tags:
        case filterType.terpenes:
            return processMultiSelectFilter(newFilters, target, filterType);
            
        case filterTypes.subcategory:
        case filterTypes.strain:
            return processSingleSelectFilter(newFilters, target, filterType);

        case filterTypes.specials:
            return processSpecialsFilter(newFilters, target);

        case 'search':
            return processSearchFilter(newFilters, target);

        default:
            return processDefaultFilter(newFilters, target, filterType);
    }
};

/**
 * Process category filter selection
 */
function processCategoryFilter(filters, target) {
    if (target.value === filterTypes.staff_picks || target.value === filterTypes.specials) {
        return {
            ...filters,
            [filterTypes.staff_picks]: target.value === filterTypes.staff_picks ? !filters.staff_picks : false,
            [filterTypes.specials]: target.value === filterTypes.specials ? !filters.specials : false
        };
    }
    
    return {
        ...filters,
        category: filters.category === target.value ? '' : target.value,
        staff_picks: false
    };
}

/**
 * Process multi-select filter (brands, effects, weights, tags)
 */
function processMultiSelectFilter(filters, target, filterType) {
    if (target.value === '') {
        return {
            ...filters,
            [filterType]: [],
            specials: false,
            staff_picks: false
        };
    }
    
    const currentFilters = Array.isArray(filters[filterType]) ? filters[filterType] : [];
    const newFilterValues = currentFilters.includes(target.value)
        ? currentFilters.filter(filter => filter !== target.value)
        : [...currentFilters, target.value];
    
    return {
        ...filters,
        [filterType]: newFilterValues,
        specials: filterType === filterTypes.brands ? filters.specials : false,
        staff_picks: false
    };
}

/**
 * Process single-select filter (subcategory, strain)
 */
function processSingleSelectFilter(filters, target, filterType) {
    return {
        ...filters,
        [filterType]: filters[filterType] === target.value ? '' : target.value,
        staff_picks: false
    };
}

/**
 * Process specials filter toggle
 */
function processSpecialsFilter(filters, target) {
    return {
        ...filters,
        specials: !filters.specials
    };
}

/**
 * Process search filter (clears search when pill is clicked)
 */
function processSearchFilter(filters, target) {
    return {
        ...filters,
        search: ''
    };
}

/**
 * Process default filter
 */
function processDefaultFilter(filters, target, filterType) {
    return {
        ...filters,
        [filterType]: target.value,
        staff_picks: false
    };
}

/**
 * Process categories to show from WordPress configuration
 */
export const processCategoriesToShow = (categoriesToShow, defaultCategories) => {
    const miscCatsToExclude = ['SPECIALS', 'DEALS'];
    
    if (Array.isArray(categoriesToShow) && categoriesToShow.length > 0) {
        return categoriesToShow
            .filter(({
                headless_categories_to_show_menu_show: shouldShow,
                headless_categories_to_show_menu_name: catName,
            }) => shouldShow && !miscCatsToExclude.includes(catName))
            .map(({ headless_categories_to_show_menu_name: catName }) => catName);
    }
    
    // Fallback to default categories
    return defaultCategories || [];
};
